import {Blog,Features,Footer,Header,Possibility,WhatGPT3} from '../container';
function Fomento(){
    return (
        <div className='App'>
      
        Fomento
        </div>
    )
}

export default Fomento


